import type { ThemeDefinition } from "vuetify";

export const theme_light: ThemeDefinition = {
   dark: false,
   colors: {
      primary: '#f6b035',
      secondary: '#4a4a50',
      tertiary: '#41A3DC',
      accent: '#ffa928',
      info: '#20a2f0',
      success: '#0aa669',
      warning: '#ff9b00',
      error: '#ff4c4f',
      surface: '#d9d9dd',
      surfaceLight: '#eeeef2',
      surfaceDark: '#b9b9bc',
      surfaceEdgeTop: '#fdfdff',
      surfaceEdgeRight: '#c6c6c8',
      surfaceEdgeBottom: '#b4b4b6',
      surfaceEdgeLeft: '#e4e4e9'
   }
};

export const theme_dark: ThemeDefinition = {
   dark: true,
   colors: {
      primary: '#f6b035',
      secondary: '#a8a8ad',
      tertiary: '#2897D7',
      accent: '#ffa928',
      info: '#20a2f0',
      success: '#0aa669',
      warning: '#ff9b00',
      error: '#ff4c4f',
      surface: '#323235',
      surfaceLight: '#46464a',
      surfaceDark: '#1c1c1d',
      surfaceEdgeTop: '#58585c',
      surfaceEdgeRight: '#242429',
      surfaceEdgeBottom: '#1c1c1d',
      surfaceEdgeLeft: '#46464a'
   }
};